import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, ToastController } from '@ionic/angular';
import { ParticipantOverview } from 'src/app/calibration/_interfaces/participant-overview.interface';
import { ReportsService } from 'src/app/reports/reports.service';
import { JobParams } from 'src/app/shared/modals/job-follow-up/models/jobs';
import { BaseClass } from '../../classes/base';
import { TranslationService } from '../../services/translation.service';
import { AiManagementEvaluationService } from '../ai-management-evaluation/ai-management-evaluation.service';
import { JobFollowUpService } from '../job-follow-up/job-follow-up.service';

@Component({
    selector: 'app-ai-general-summary-modal',
    templateUrl: './ai-general-summary-modal.component.html',
    styleUrls: ['./ai-general-summary-modal.component.scss'],
})
export class AiGeneralSummaryModalComponent extends BaseClass implements OnInit {

    @Input() set participantOverview(value: Partial<ParticipantOverview>) {
        this.participant = value;
    }

    @Input() public cycleParticipantId: number;
    @Input() public isExportMode: boolean = false;
    @Input() public cycleId: number;
    @Input() public calibrationProcessId: number;
    @Input() public groupId: number;
    @Input() public managerEvaluationView: boolean;

    public participant: Partial<ParticipantOverview>;

    public notify: (message: string, color?: string, duration?: number) => Promise<void>;
    public notifyError: (message: string, frontendValidation?: boolean) => Promise<void>;

    constructor(
        private _modalController: ModalController,
        private _router: Router,
        protected _toastController: ToastController,
        protected _translationService: TranslationService,
        protected _aiManagementEvaluationService: AiManagementEvaluationService,
        private _jobFollowUpService: JobFollowUpService,
        private _reportService: ReportsService,
    ) {
        super(_toastController, _translationService);
    }

    ngOnInit() { }


    public viewFullReport(): void {
        localStorage.setItem(
            'FinalReport_ReturnPath',
            this.managerEvaluationView ?
                'manager-evaluation/' + this.cycleId :
                'calibration/' + this.cycleId + '/' + this.calibrationProcessId + '/' + this.groupId
        );

        this.dismiss(true);
        this._router.navigate([
            'final-report/' + this.cycleId + '/' + this.participant.user.userId
        ]);
    }
  
    public async dismiss(closeParent:boolean = false): Promise<void> {
        await this._modalController.dismiss({closeParent});
    }

    public async export(): Promise<void> {
        const reportType = 'exportAiSummaryEvaluation';
        this._aiManagementEvaluationService.exportAiSummaryReport(
            this.cycleId,
            this.groupId,
            this.cycleParticipantId
        ).subscribe(response => {
            const jobId = response.data;
            this.notify(this._translationService.getTranslation('Report.SendByEmail'), 'success');

            //create_review_summary_pdf_report
            const jobName = `Ai Review Summary`;
            this._startPollingForJobProgress({ jobId: jobId, type: reportType, jobName: jobName });

            this.dismiss(true);
        }, (error) => {
            this.notifyError(error);
        });
    }

    private _startPollingForJobProgress(job: Partial<JobParams>) {
        const service$ = () => this._reportService.getJobStatus(job.jobId);
        this._jobFollowUpService.startPollingForJobProgress(service$, {
            jobId: job.jobId,
            filters: undefined,
            cycleId: this.cycleId,
            jobName: job.jobName,
            group: this.groupId,
            downloaded: false,
            processId: this.calibrationProcessId,
            type: job.type,
        });
    }

}
